export var dateRegExp = function dateRegExp() {
  var year = new Date().getFullYear();
  var leapYear = year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;

  /* eslint max-len: ["error", { "ignoreRegExpLiterals": true }] */

  var leapYearDateRegex = /^(?:3|$)(?:1|$)(?:\/|$)(?:(?:(?:0|$)?(?:[13578]|$)|(?:1|$)(?:[02]|$))|$)$|^(?:(?:((?:2|$)(?:9|$))(?:\/|$)(?:(?:0|$)?(?:[1-9]|$)|(?:1|$)(?:[0-2]|$))|((?:3|$)(?:0|$))(?:\/|$)(?:(?:0|$)?(?:[1,3-9]|$)|(?:1|$)(?:[0-2]|$))))$|^(?:(?:0|$)?(?:[1-9]|$)|(?:1|$)(?:\d|$)|(?:2|$)(?:[0-8]|$))(?:\/|$)(?:(?:(?:(?:0|$)?(?:[1-9]|$))|(?:(?:1|$)(?:[0-2]|$)))|$)$/;
  var nonLeapYearDateRegex = /^(?:3|$)(?:1|$)(?:\/|$)(?:(?:(?:0|$)?(?:[13578]|$)|(?:1|$)(?:[02]|$))|$)$|^(?:(?:(?:2|$)(?:9|$)|(?:3|$)(?:0|$))(?:\/|$)(?:(?:0|$)?(?:[1,3-9]|$)|(?:1|$)(?:[0-2]|$)))$|^(?:(?:0|$)?(?:[1-9]|$)|(?:1|$)(?:\d|$)|(?:2|$)(?:[0-8]|$))(?:\/|$)(?:(?:(?:(?:0|$)?(?:[1-9]|$))|(?:(?:1|$)(?:[0-2]|$)))|$)$/;
  return leapYear ? leapYearDateRegex : nonLeapYearDateRegex;
};
export var timeRegExp = function timeRegExp() {
  return /^(([0-1]?)([0-9])?|2[0-3]?):?([0-5][0-9]?)?$/;
};